import { Box, ImageProps } from "@chakra-ui/react";
import { useMemo } from "react";

export interface FlickrImageProps extends ImageProps {
  farm: string;
  server: string;
  id: string;
  secret: string;
}

const VERSIONS = [
  // { key: "Square", width: 75, height: 75, versionKey: "_s", media: "" },
  // { key: "Large Square", width: 150, height: 150, versionKey: "_q", media: "" },
  {
    key: "Thumbnail",
    width: 100,
    height: 75,
    versionKey: "_t",
    media: "(max-width: 0px)",
  },
  {
    key: "Small",
    width: 240,
    height: 180,
    versionKey: "_m",
    media: "(max-width: 240px)",
  },
  {
    key: "Small 320",
    width: 320,
    height: 240,
    versionKey: "_n",
    media: "(max-width: 320px)",
  },
  {
    key: "Medium",
    width: 500,
    height: 375,
    versionKey: "",
    media: "(max-width: 500px)",
  },
  {
    key: "Medium 640",
    width: 640,
    height: 480,
    versionKey: "_z",
    media: "(max-width: 640px)",
  },
  {
    key: "Medium 800",
    width: 800,
    height: 600,
    versionKey: "_c",
    media: "(max-width: 800px)",
  },
  {
    key: "Large",
    width: 1024,
    height: 768,
    versionKey: "_b",
    media: "(min-width: 1024px)",
  },
];

export default function FlickrImage({
  farm,
  server,
  id,
  secret,
  alt,
  className,
}: FlickrImageProps) {
  const { srcSet, sizes } = useMemo(() => {
    const srcSet = [];
    const sizes = [];
    for (const version of VERSIONS) {
      const src = `https://farm${farm}.staticflickr.com/${server}/${id}_${secret}${version.versionKey}.jpg`;
      srcSet.push(`${src} ${version.width}w`);
      sizes.push(`${version.media} ${version.width}w`);
    }

    return {
      srcSet: srcSet.join(",\r\n"),
      sizes: sizes.join(",\r\n"),
    };
  }, []);
  return (
    <Box overflow="hidden">
      <Box
        as="img"
        srcSet={srcSet}
        sizes={sizes}
        src={`https://farm${farm}.staticflickr.com/${server}/${id}_${secret}.jpg`}
        alt={alt}
        width="100%"
        loading="lazy"
        gridRow="1 / -1"
        gridColumn="1"
        className={className}
        minH="220px"
      />
    </Box>
  );
}
